import {
    GET_DOCTOR_ASSISTANT_STATUS
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    doctor_assistant_status: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DOCTOR_ASSISTANT_STATUS: {
            return {
                ...state,
                doctor_assistant_status: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
